const SessaoModule = {
    state: {
        logado: false
    },
    getters: {
        getLogado(state) {
            return state.logado;
        }
    },
    mutations: {
        setLogado(state, logado) {
            state.logado = logado;
        }
    },
    actions: {
        
    }
}

export default SessaoModule;